import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import plusSquareOutline from '@iconify/icons-eva/plus-square-outline';
import minusSquareOutline from '@iconify/icons-eva/minus-square-outline';
import closeSquareOutline from '@iconify/icons-eva/close-square-outline';
import { Box } from '@material-ui/core';
const ICON_SIZE = { width: 20, height: 20 };
export default function TreeView(theme) {
    return {
        MuiTreeView: {
            defaultProps: {
                defaultCollapseIcon: _jsx(Icon, Object.assign({ icon: minusSquareOutline }, ICON_SIZE), void 0),
                defaultExpandIcon: _jsx(Icon, Object.assign({ icon: plusSquareOutline }, ICON_SIZE), void 0),
                defaultEndIcon: (_jsx(Box, Object.assign({ component: Icon, icon: closeSquareOutline }, ICON_SIZE, { sx: { color: 'text.secondary' } }), void 0)),
            },
        },
        MuiTreeItem: {
            styleOverrides: {
                label: { ...theme.typography.body2 },
                iconContainer: { width: 'auto' },
            },
        },
    };
}
//# sourceMappingURL=TreeView.js.map